// BorderAnimation.js
import React, { useState, useRef, useLayoutEffect } from "react";
import "./BorderAnimation.css";

export default function BorderBox({ visible, animate = false, toggle, text='', activeText='', inActiveText='' }) {
  const wrapperRef = useRef(null);
  const pathRef    = useRef(null);
  const prevVisRef = useRef(visible);
  const firstPaint = useRef(true);         // <-- NEW

  /** Build a rounded-rect path string for the given w/h. */
  const buildPath = (w, h, r = 10) =>
    `M ${w / 2} ${h} L ${r} ${h} A ${r} ${r} 0 0 1 0 ${h - r}
     L 0 ${r} A ${r} ${r} 0 0 1 ${r} 0 L ${w - r} 0
     A ${r} ${r} 0 0 1 ${w} ${r} L ${w} ${h - r}
     A ${r} ${r} 0 0 1 ${w - r} ${h} L ${w / 2} ${h} Z`;

  useLayoutEffect(() => {
    const wrapper = wrapperRef.current;
    const path    = pathRef.current;
    if (!wrapper || !path) return;

    /* helper to (re)draw the path without triggering the dash animation */
    const redraw = () => {
      const { width: w, height: h } = wrapper.getBoundingClientRect();

      // 1. Freeze transition so we don’t animate on resize
      const saved = path.style.transition;
      path.style.transition = "none";

      // 2. Update the actual <path d="…">
      path.setAttribute("d", buildPath(w, h));

      // 3. Restore dash-offset according to current visibility
      path.style.strokeDashoffset = visible ? "0" : "100";

      // 4. Restore previous transition definition
      path.style.transition = saved;
    };

    /* run once now */
    redraw();

    /* run again on every resize (ResizeObserver is fast & flicker-free) */
    const ro = new ResizeObserver(redraw);
    ro.observe(wrapper);

    return () => ro.disconnect();
  }, [visible]); // re-run if `visible` flips while mounted

  /*  Handle animation whenever `visible` changes  */
  useLayoutEffect(() => {
    const path = pathRef.current;
    if (!path) return;

    console.log('!!!!!!firstPaint:', firstPaint.current, visible);
    /*
    if (firstPaint.current) {
      path.style.transition       = 'none';
      path.style.strokeDashoffset = visible ? '0' : '100';
      firstPaint.current = false;
      prevVisRef.current = visible;
      return;                     // nothing else
    }
    */

    const changed = prevVisRef.current !== visible;
    path.style.transition = animate && changed ? "stroke-dashoffset 3s ease-in-out" : "none";
    path.style.strokeDashoffset = visible ? "0" : "100";
    prevVisRef.current = visible;
  }, [visible, animate]);

  return (
    <div className="border-box-wrapper" ref={wrapperRef}>
      <svg className="border-svg">
        <path
          ref={pathRef}
          /*d={pathD}*/
          className="border-path"
          vectorEffect="non-scaling-stroke"
          pathLength="100"
        />
      </svg>

      <div className="d-flex content-box" onClick={toggle}>
        <p className="mb-0" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {(activeText || inActiveText) && visible ? activeText : inActiveText}
          {!(activeText || inActiveText) && text}
        </p>
      </div>
    </div>
  );
}




